import Swiper, { Autoplay, Navigation } from 'swiper';

export default () => {
  const AchievementSlider = new Swiper('.js-achievement-slider', {
    modules: [Autoplay, Navigation],
    speed: 500,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 24,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.slider-button-next',
      prevEl: '.slider-button-prev',
    },

    breakpoints: {
      600: {
        slidesPerView: 2,
        centeredSlides: true,
      },
      905: {
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });
};
